import { render } from "./base-breadcrumb.vue?vue&type=template&id=55ef1994&ts=true"
import script from "./base-breadcrumb.vue?vue&type=script&lang=ts"
export * from "./base-breadcrumb.vue?vue&type=script&lang=ts"

import "./base-breadcrumb.vue?vue&type=style&index=0&id=55ef1994&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__